export function getProject (state) {
  return state.project;
}
